import { Component, Input, OnInit } from '@angular/core';
import { ChartService } from './chart.service';
import {
  QuestionStatusModal,
  ScoreTrendModel,
  TrendModal,
  chartColors,
} from './chart.model';
import { Subscription } from 'rxjs';
import { ParentChildrenService } from 'src/app/services/parent-children.service';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements OnInit {
  basicData: any;

  multiAxisData: any;

  multiAxisOptions: any;

  lineStylesData: any;

  basicOptions: any = {
    plugins: {
      legend: {
        labels: {
          color: 'black',
        },
      },
      // title: {
      //   display: true,
      //   text: 'Score trend',
      // },
      tooltip: {
        // enabled: false,
        // position: 'nearest',
        // external: this.createTooltip,
        callbacks: {
          afterBody: (context: any) => {
            if (context[0].datasetIndex === 0) {
              let trendString = ``;
              const sections =
                this.trends[this.selectedTrendType].trends[context[0].dataIndex]
                  .sections;
              sections.forEach((section, sectionIndex) => {
                trendString += `${section.sectionName}: ${section.score} ${
                  sections.length !== sectionIndex + 1 ? '\n' : ''
                }`;
              });
              return trendString;
            }
            return '';
          },
        },
      },
    },
  };

  data: any;

  chartOptions: any;

  trends: TrendModal[] = [];
  selectedTrendType: number = 0;
  status: QuestionStatusModal[] = [];
  selectedStatusType: number = 0;
  chartColors: string[] = chartColors;
  plugins: any = [
    {
      tooltip: {
        // enabled: false,
        // position: 'nearest',
        // external: (chart: any) => {
        //   alert("I'm into external");
        //   this.createTooltip(chart);
        // },
        callbacks: {
          beforeBody: () => {
            return 'my before';
          },
          afterBody: () => {
            return 'after body';
          },
        },
      },
    },
  ];
  trendDataLoading: boolean = false;
  areaFocusLoading: boolean = false;
  @Input('studentId') studentId: number | null = null;
  myStudentId: number | null = null;
  parentChildChangeSubscription: Subscription | undefined;
  childrenListSubscription: Subscription | undefined;
  children: any[] = [];
  constructor(
    private chartService: ChartService,
    private parentChildrenServcie: ParentChildrenService
  ) {
    // this.basicData = {
    //   labels: [
    //     'Test 1',
    //     'Test 2',
    //     'Test 3',
    //     'Test 4',
    //     'Test 5',
    //     'Test 6',
    //     'Test 7',
    //   ],
    //   datasets: [
    //     {
    //       label: 'Your score',
    //       data: [65, 59, 80, 81, 56, 55, 40],
    //       fill: false,
    //       borderColor: '#42A5F5',
    //       tension: 0.4,
    //     },
    //     {
    //       label: 'Average Class Score',
    //       data: [28, 48, 40, 19, 86, 27, 90],
    //       fill: false,
    //       borderColor: '#FFA726',
    //       tension: 0.4,
    //     },
    //   ],
    // };
    this.childrenListSubscription = this.parentChildrenServcie
      .getChildren()
      .subscribe({
        next: (children: any[]) => {
          this.children = children;
        },
      });
  }

  ngOnInit(): void {
    // this.data = {
    //   labels: ['Tables', 'Statistics', 'Trigonometry', 'Matrices'],
    //   datasets: [
    //     {
    //       data: [40, 20, 30, 40],
    //       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#44bb74'],
    //       hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#44bb74'],
    //     },
    //   ],
    // };
    if (localStorage['roleId'] === '3') {
      this.myStudentId = localStorage['userId']
        ? parseInt(localStorage['userId'])
        : null;
      this.getScoreTrendData();
    } else if (localStorage['roleId'] === '4') {
      this.parentChildChangeSubscription = this.parentChildrenServcie
        .getSelectedChildren()
        .subscribe({
          next: (index: string) => {
            if (this.children.length > 0) {
              const childIndex: number = parseInt(index);
              this.myStudentId = this.children[childIndex].student_id;
              this.getScoreTrendData();
            }
          },
        });
    }

    // this.getQuestionStats();
  }

  applydata() {
    this.chartOptions = {
      indexAxis: 'y',
      plugins: {
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        legend: {
          labels: {
            color: '#495057',
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: '#495057',
          },
          grid: {
            color: '#ebedef',
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: '#495057',
          },
          grid: {
            color: '#ebedef',
          },
        },
      },
    };
  }

  createTooltip(chart: any) {
    alert("I'm reached");
    console.log(chart);
  }

  getBasicScoreTrendDataset(): any {
    return [
      {
        label: 'Your score',
        data: [],
        fill: false,
        backgroundColor: '#42A5F5',
        borderColor: '#42A5F5',
        tension: 0.4,
      },
      // {
      //   label: 'Average Class Score',
      //   data: [],
      //   fill: false,
      //   backgroundColor: '#FFA726',
      //   borderColor: '#FFA726',
      //   tension: 0.4,
      // },
    ];
  }

  getScoreTrendData() {
    if (this.myStudentId) {
      this.trendDataLoading = true;
      this.chartService.getScoreTrend(this.myStudentId).subscribe({
        next: (scoreTrends: ScoreTrendModel[]) => {
          this.trendDataLoading = false;
          console.log(scoreTrends);
          const trends: TrendModal[] = [];
          scoreTrends.forEach((scoreTrend) => {
            let totalScore: number = 0;
            scoreTrend.sections.forEach((section) => {
              totalScore += section.score;
            });
            scoreTrend.totalScore = totalScore;
            if (scoreTrend.testGroup === 1) {
              const trendIndex = trends.findIndex(
                (trend) => trend.testType === scoreTrend.testType
              );
              if (trendIndex < 0) {
                trends.push({
                  trends: [scoreTrend],
                  testType: scoreTrend.testType,
                  testTypeId: scoreTrend.testTypeId,
                });
              } else {
                trends[trendIndex].trends.push(scoreTrend);
              }
            }
          });
          this.trends = trends;
          console.log(trends);
          if (this.trends.length > 0) this.selectTrendType();
        },
        error: (error: any) => {
          console.log(error);
          this.trendDataLoading = false;
        },
      });
    }
  }

  selectTrendType() {
    const labels: string[] = [];
    const datasets: any[] = this.getBasicScoreTrendDataset();
    this.getQuestionStats(this.trends[this.selectedTrendType].testTypeId);
    this.trends[this.selectedTrendType].trends.forEach((trend) => {
      labels.push(trend.testName);
      datasets[0].data.push(trend.totalScore || 0);
      // datasets[1].data.push(trend.avgScore);
    });
    this.basicData = {
      labels,
      datasets,
    };
    /*this.basicOptions = {
      title: {
        display: true,
        text: 'Score Trend',
      },
      // tooltip: {
      //   enabled: false,
      //   position: 'nearest',
      //   external: (chart: any) => {
      //     alert("I'm into external");
      //     this.createTooltip(chart);
      //   },
      // },
    };*/
  }

  getQuestionStats(testTypeId: number) {
    if (this.myStudentId) {
      this.areaFocusLoading = true;
      this.chartService
        .getQuestionStats(testTypeId, this.myStudentId)
        .subscribe({
          next: (stats: QuestionStatusModal[]) => {
            this.areaFocusLoading = false;
            this.status = stats;
            this.status.forEach((stat) => {
              stat.questionStatistics.forEach((statistic) => {
                // const wrongAnswers: number = statistic.wrongAnswers || 0;
                // const correctAnswers: number = statistic.correctAnswers || 0;
                statistic.wrongAnswers = statistic.wrongAnswers || 0;
                statistic.correctAnswers = statistic.correctAnswers || 0;
                // statistic.percentile =
                //   wrongAnswers + correctAnswers > 0
                //     ? parseFloat(
                //         (
                //           (wrongAnswers / (wrongAnswers + correctAnswers)) *
                //           100
                //         ).toFixed(2)
                //       )
                //     : 0;
              });
              // stat.questionStatistics.sort((firstStatistic, secondStatistic) => {
              //   return firstStatistic.percentile! - secondStatistic.percentile!;
              // });
              // if (stat.questionStatistics.length > 4) {
              //   stat.questionStatistics.splice(4);
              // }
            });
            if (this.status.length > 0) {
              this.selectQuestionType();
            }
          },
          error: (error: any) => {
            console.log(error);
            this.areaFocusLoading = false;
          },
        });
    }
  }

  selectQuestionType() {
    const labels: string[] = [];
    const correct: number[] = [];
    const wrong: number[] = [];
    // let index: number = 0;
    if (this.status.length > 0) {
      this.status[this.selectedStatusType].questionStatistics.forEach(
        (statistic) => {
          console.log(statistic);
          // if (statistic.wrongAnswers + statistic.correctAnswers > 0) {
          labels.push(statistic.subTopic);
          correct.push(statistic.correctAnswers || 0);
          wrong.push(statistic.wrongAnswers || 0);
          // index++;
          // }
        }
      );
    }
    console.log(labels, correct, wrong);
    this.data = {
      labels,
      // datasets: [
      //   {
      //     data,
      //     backgroundColor: colors,
      //     hoverBackgroundColor: colors,
      //   },
      // ],
      datasets: [
        {
          type: 'bar',
          label: 'Wrong Questions',
          backgroundColor: '#f23839',
          data: wrong,
        },
        {
          type: 'bar',
          label: 'Correct Questions',
          backgroundColor: '#27e227',
          data: correct,
        },
      ],
    };
    this.applydata();
  }
}
